import React from 'react'
import USTemplateDefault from 'src/components/template/us'
import { leagueIds, sportIds } from 'src/constants/personalizationIds'

export default (props) => {
  return (
  <USTemplateDefault
    location={props.location}
    lang="en"
    market="us"
    video={'https://assets.fubo.tv/marketing/lp/videos/compressed/NBA_ESPN_2021_LP_20s.mp4'}
    title="Watch the NBA on ESPN"
    subtitle="Live games, expert analysis and more"
    ctaText="Start Watching"
    networkSet="basketball"
    league="nba"
    showRSN={true}
    sportId={sportIds.Basketball}
    leagueId={leagueIds.NBA}
    // matchtickerSportId="59"
    // matchtickerLeagueName="NBA"
    // matchtickerLeagueId="191276"
  />
  )
}
